/* ============================================================
   BoT App-UI Port v4 — home blocks + Liquid Glass lens engine for .bottom-nav
   v3: rect-based visible() (offsetParent is null on position:fixed
   bars, which blocked boot entirely in v2), live node collection,
   MutationObserver re-sync, delayed boot, inline dock hardening.
   ES5. No external deps.
   ============================================================ */
(function(){
  "use strict";
  if (window.__botAppUI) return; window.__botAppUI = true;

  function ready(fn){
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function(){

    /* ---- home blocks: weekday greeting, relocate Smart Analysis +
       AM/PM routes into the page flow, gold sub-kickers ---- */
    (function(){
      var greet = document.getElementById("buiGreet");
      if (greet){
        var days = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
        var gp = greet.getAttribute("data-prefix") || "Happy";
        var gs = greet.getAttribute("data-suffix") || "Beautiful.";
        greet.innerHTML = gp + " " + days[new Date().getDay()] + ",<br>" + gs;
      }
    })();

    var bar = document.querySelector(".bottom-nav");
    if (!bar) return;
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    /* ---- LIVE item collection: re-query every time ---- */
    function getItems(){
      var out = [];
      for (var i = 0; i < bar.children.length; i++){
        var c = bar.children[i];
        if (c.tagName === "A" || c.tagName === "BUTTON") out.push(c);
      }
      return out;
    }

    /* wrap stray text nodes so labels can fade in min state */
    function wrapLabels(){
      getItems().forEach(function(el){
        for (var n = el.childNodes.length - 1; n >= 0; n--){
          var nd = el.childNodes[n];
          if (nd.nodeType === 3 && nd.textContent.replace(/\s+/g, "")){
            var sp = document.createElement("span");
            sp.className = "bn-lb";
            sp.textContent = nd.textContent.trim();
            el.replaceChild(sp, nd);
          } else if (nd.nodeType === 1 && nd.tagName === "SPAN"){
            nd.classList.add("bn-lb");
          }
        }
      });
    }

    /* inject lens */
    var lens = document.createElement("div");
    lens.className = "bn-lens";
    bar.insertBefore(lens, bar.firstChild);

    /* geometry — items + centers refreshed together */
    var items = [], centers = [], barLeft = 0, barW = 0, lensW = 60;
    function visible(){
      var r = bar.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    }
    function measure(){
      if (!visible()) return;
      items = getItems();
      var br = bar.getBoundingClientRect();
      barLeft = br.left; barW = br.width;
      centers = items.map(function(el){
        var r = el.getBoundingClientRect();
        return r.left - br.left + r.width / 2;
      });
      if (items.length){
        lensW = Math.max(54, Math.min(76, (items[0].getBoundingClientRect().width || 60) + 6));
        lens.style.width = lensW + "px";
      }
    }

    function nearestIdx(x){
      var best = 0, bd = 1e9;
      for (var i = 0; i < centers.length; i++){
        var d = Math.abs(centers[i] - x);
        if (d < bd){ bd = d; best = i; }
      }
      return best;
    }

    /* spring state */
    var X = 0, V = 0, TX = 0, mode = "snap", running = false, lastT = 0;
    var dragging = false, dragMoved = false, curIdx = 0, lastNear = -1;
    var K_SNAP = 560, C_SNAP = 32, K_FOLLOW = 820, C_FOLLOW = 46;

    function render(){
      var sx = 1 + Math.min(.10, Math.abs(V) * .0012) + (dragging && dragMoved ? .02 : 0);
      var sy = Math.max(.95, 1 - (sx - 1) * .5);
      lens.style.transform = "translateX(" + (X - lensW / 2) + "px) scale(" + sx.toFixed(3) + "," + sy.toFixed(3) + ")";
      if (!reduce){
        for (var i = 0; i < items.length; i++){
          var d = centers[i] - X;
          var g = Math.exp(-(d * d) / 3872);
          items[i].style.transform = "translateY(" + (-1.5 * g).toFixed(2) + "px) scale(" + (1 + .07 * g).toFixed(3) + ")";
        }
      }
      var n = nearestIdx(X);
      if (n !== lastNear){
        lastNear = n;
        if (dragging && navigator.vibrate){ try{ navigator.vibrate(5); }catch(e){} }
      }
    }

    function step(t){
      if (!lastT) lastT = t;
      var dt = Math.min(.032, (t - lastT) / 1000); lastT = t;
      var k = mode === "snap" ? K_SNAP : K_FOLLOW;
      var c = mode === "snap" ? C_SNAP : C_FOLLOW;
      var a = k * (TX - X) - c * V;
      V += a * dt; X += V * dt;
      render();
      if (!dragging && Math.abs(V) < .02 && Math.abs(TX - X) < .1){
        X = TX; V = 0; render(); running = false; lastT = 0; return;
      }
      requestAnimationFrame(step);
    }
    function run(){ if (!running){ running = true; lastT = 0; requestAnimationFrame(step); } }

    function snapTo(idx, instant){
      curIdx = idx; TX = centers[idx] || 0; mode = "snap";
      if (instant || reduce){ X = TX; V = 0; render(); }
      else run();
    }

    /* unified tap + drag: release commits nearest LIVE item */
    var allowClick = false, suppressNext = false;
    bar.addEventListener("click", function(e){
      if (allowClick) return;
      if (suppressNext){
        suppressNext = false;
        e.preventDefault(); e.stopPropagation();
      }
    }, true);

    function commit(idx){
      snapTo(idx);
      var el = items[idx];
      if (!el || !el.isConnected){ measure(); el = items[idx]; }
      if (!el) return;
      allowClick = true;
      try{ el.click(); } finally { allowClick = false; }
    }

    bar.addEventListener("pointerdown", function(e){
      if (!visible()) return;
      measure();
      dragging = true; dragMoved = false;
      mode = "follow";
      TX = Math.max(lensW/2, Math.min(barW - lensW/2, e.clientX - barLeft));
      try{ bar.setPointerCapture(e.pointerId); }catch(err){}
      e.preventDefault();
      run();
    });
    bar.addEventListener("pointermove", function(e){
      if (!dragging) return;
      var x = Math.max(lensW/2, Math.min(barW - lensW/2, e.clientX - barLeft));
      if (Math.abs(x - TX) > 3) dragMoved = true;
      TX = x; run();
    });
    function endDrag(e, cancel){
      if (!dragging) return;
      dragging = false;
      suppressNext = true;
      if (cancel){ snapTo(curIdx); return; }
      var idx = nearestIdx(Math.max(0, Math.min(barW, e.clientX - barLeft)));
      commit(idx);
    }
    bar.addEventListener("pointerup", function(e){ endDrag(e, false); });
    bar.addEventListener("pointercancel", function(e){ endDrag(e, true); });

    /* re-sync when beauty-bottom-sheet.js swaps the buttons */
    if (window.MutationObserver){
      new MutationObserver(function(){
        wrapLabels();
        measure();
        snapTo(curIdx, true);
      }).observe(bar, { childList: true });
    }

    /* scroll-minimise (bn-min) removed 5 Jul 2026 per T — the shrink/restore
       cycle while scrolling read as a glitch. Bar now keeps a constant height. */

    window.addEventListener("resize", function(){
      applyDockSkin();
      measure(); snapTo(curIdx, true);
    });

    /* inline dock hardening — beats any stylesheet conflict */
    function applyDockSkin(){
      if (window.innerWidth > 991){
        bar.style.cssText = bar.style.cssText
          .replace(/left:[^;]+;?|right:[^;]+;?|bottom:[^;]+;?|border-radius:[^;]+;?/g, "");
        return;
      }
      var s = bar.style;
      s.left = "10px"; s.right = "10px";
      s.bottom = "calc(10px + env(safe-area-inset-bottom, 0px))";
      s.borderRadius = "30px";
      s.background = "linear-gradient(180deg, rgba(255,255,255,.7), rgba(255,255,255,.5))";
      s.webkitBackdropFilter = "blur(22px) saturate(185%)";
      s.backdropFilter = "blur(22px) saturate(185%)";
      s.border = "1px solid rgba(255,255,255,.7)";
      s.boxShadow = "0 12px 30px rgba(40,30,12,.18), 0 2px 6px rgba(40,30,12,.07), inset 0 1px 0 rgba(255,255,255,.9)";
      s.padding = "0 6px";
    }

    /* initial rest: item matching this page, else first item */
    function initialIdx(){
      try{
        for (var i = 0; i < items.length; i++){
          if (items[i].tagName === "A" && items[i].href){
            var u = new URL(items[i].href, location.origin);
            if (u.pathname === location.pathname) return i;
          }
        }
      }catch(e){}
      return 0;
    }

    /* boot AFTER the sheet engine's clone pass (it runs at
       DOMContentLoaded / +100ms) — 350ms covers it, then the
       MutationObserver covers anything later */
    var bootTries = 0;
    function boot(){
      /* bar stays hidden on desktop (min-width:992px) — stop polling after ~10s
         instead of retrying forever */
      if (!visible()){ if (++bootTries < 40) setTimeout(boot, 250); return; }
      wrapLabels();
      applyDockSkin();
      measure();
      snapTo(initialIdx(), true);
    }
    setTimeout(boot, 350);
  });
})();
